import { environment } from 'src/environments/environment'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { ConfigOptionsKeys } from 'src/app/shared/constants'

@Component({
  selector: 'notification-status-card',
  templateUrl: './notification-status.component.html',
  styleUrls: ['./notification-status.component.scss']
})
export class NotificationStatusComponent implements OnInit {
  @Input() formValues: any
  @Input() regCategorieOptions$: Observable<any>
  @Output() onSubmit = new EventEmitter<any>()
  public isCollapsedRegCategoryFilter = true
  public form: UntypedFormGroup
  public options$: Observable<any[]>
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      notifications: [null, []],
      emailNewsletterAgreement: [null, []],
      emailOffersAgreement: [null, []]
    })

    if (this.formValues) {
      this.form?.patchValue(this.formValues)
      if (!this.formValues.notifications) {
        this.form.patchValue({
          emailNewsletterAgreement: false,
          emailOffersAgreement: false
        })
      }
    }
  }

  public patchValueForm(field, value: boolean) {
    let patchValue = {}
    patchValue[field] = value
    this.form.patchValue(patchValue)
    if (field == 'notifications' && !value) {
      this.form.patchValue({
        emailNewsletterAgreement: false,
        emailOffersAgreement: false
      })
    }
  }

  public onSubmitNotification() {
    this.onSubmit.emit({
      key: ConfigOptionsKeys.NOTIFICATIONS_AGREEMENTS_DISPLAY_NEWSLETTERS,
      valueToSave: this.form.controls.emailNewsletterAgreement.value
    })
    this.onSubmit.emit({
      key: ConfigOptionsKeys.NOTIFICATIONS_AGREEMENTS_DISPLAY_OFFERS,
      valueToSave: this.form.controls.emailOffersAgreement.value
    })
    this.onSubmit.emit({
      key: ConfigOptionsKeys.NOTIFICATIONS_AGREEMENTS_DISPLAY,
      valueToSave: this.form.controls.notifications.value
    })
  }
}
